<div class="mb-4 flex justify-end">
  @if (statusId != 1 && statusId != 5 && statusId != 6 && statusId != 9) {
    <button mat-raised-button class="btn-add" (click)="addItemProposal()">
      Cadastrar
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
<div>
  <!--  <form-client-search-->
  <!--    [search]="inputSearchContact"-->
  <!--    [listSearch]="listSearch"-->
  <!--    (responseSearch)="search($event)"-->
  <!--  />-->

  @if (!loading) {
    <div class="tab-overflow">
      <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
        @for (column of columns; track column.keyColumn) {
          <ng-container matColumnDef="{{ column.keyColumn }}">
            <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
            <td mat-cell *matCellDef="let element">
              @if (column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  <!--                  @if (element.statusId != 1) {-->
                  <mat-icon
                    class="btn-icon-outline"
                    fontIcon="edit"
                    (click)="selectItemEvent(element)"
                  />
                  @if (
                    statusId != 1 &&
                    statusId != 5 &&
                    statusId != 6 &&
                    statusId != 9
                  ) {
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="delete"
                      (click)="deleteItemEvent(element)"
                    />
                    <mat-icon
                      class="btn-icon-outline"
                      fontIcon="library_add"
                      (click)="duplicateItemProposal(element)"
                    />
                  }

                  <!--                  } @else if (element.statusId == 1) {-->
                  <!--                    <mat-icon-->
                  <!--                      class="btn-icon-outline"-->
                  <!--                      fontIcon="visibility"-->
                  <!--                      (click)="selectItemEvent(element)"-->
                  <!--                    />-->
                  <!--                  }-->
                  <!--                  @if (column.key.delete) {-->
                  <!--                    <mat-icon-->
                  <!--                      class="btn-icon-outline"-->
                  <!--                      fontIcon="delete"-->
                  <!--                      (click)="deleteItemEvent(element)"-->
                  <!--                    />-->
                  <!--                  }-->
                </div>
              } @else if (column.keyColumn == 'cost_IP') {
                <b>Valor: </b>{{ element.valorVendaFormatado }}<br />
                <b>C. Taxa: </b>{{ element.valorVendaTaxaFormatado }}
              } @else if (column.keyColumn == 'location_OD') {
                <b>Origem</b><br />
                Cidade: {{ element.cidadeOrigem }}<br />
                Estado: {{ element.estadoOrigem }}<br />
                <b>Destino</b><br />
                Cidade: {{ element.cidadeDestino }}<br />
                Estado: {{ element.estadoDestino }}
                <!--                <b>Origem: </b>{{ element.origem }}<br />-->
                <!--                <b>Destino: </b>{{ element.destino }}-->
              } @else if (column.keyColumn == 'servico_TS') {
                <b>Tipo: </b>{{ element.descricaoTipoServico }}<br />
                <b>Serviço: </b>{{ element.descricaoServico }}
              } @else if (column.keyColumn == 'vehicle_VM') {
                <b>Tipo veículo: </b>{{ element.descricaoTipoVeiculo }}<br />
                <b>Tipo motorista: </b>{{ element.descricaoTipoMotorista }}
              } @else if (column.keyColumn == 'custoExtra_HK') {
                <b>Hora: </b>{{ element.valorKmVendaFormatado }}<br />
                <b>KM: </b>{{ element.valorHoraVendaFormatado }}
              } @else {
                {{ element[column.key] }}
              }
            </td>
          </ng-container>
        }
        <tr
          mat-header-row
          class="style-header"
          *matHeaderRowDef="displayedColumns"
        ></tr>
        <tr
          mat-row
          class="style-row"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>
  } @else {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (!loading) {
    <mat-paginator
      #paginator
      [length]="numberRows"
      [pageSize]="rows"
      [pageIndex]="page - 1"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="pageChanged($event)"
    >
    </mat-paginator>
  }
</div>
